import {useLocation} from 'react-router-dom';

import type {EvalProduct} from 'src/lib/api/eval';

import SeasonalSiteDetail from './SeasonalSiteDetail';
import EvalSiteDetail from './SiteDetail';

export default function EvalSiteDetailRouter() {
  const {search} = useLocation();
  const params = new URLSearchParams(search);
  const horizon = params.get('horizon') as EvalProduct | null;

  if (horizon === 'seasonal') {
    return <SeasonalSiteDetail />;
  }
  return <EvalSiteDetail />;
}
